import canineIMG from "/assets/canine.png";

export default (st) => `
<header>
<div class="contenttext">
          <h2><img id="mainlogo" src="${canineIMG}"/></h2>
</div>
</header>
`;
